import React, { Fragment } from "react";
import { bool } from "prop-types";
import { useDispatch } from "react-redux";
import { goBack, push } from "connected-react-router";
import * as i18n from "util/i18n";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import CustomText from "pages/_components/CustomText/CustomText";

const StepStart = ({ isMobile }) => {
    const dispatch = useDispatch();

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const onStart = () => {
        dispatch(push("/onboarding/StepCUIT"));
    };

    return (
        <Fragment>
            <Notification scopeToShow="login" />
            {isMobile && (
                <ResponsiveHeader ticket id="onboarding.enrolled.user" onClickBack={isMobile && onHeaderBack} />
            )}{" "}
            <MainContainer className="onboarding step-start">
                <CustomText
                    text={i18n.get(
                        "onboarding.enrolled.user.stepStart.1",
                        "Completá los siguientes pasos para empezar a operar en tu nueva empresa.",
                    )}
                />
                <div className="box box-shadow three-step-box">
                    <div className="paso1">
                        <div>
                            <b>
                                <CustomText className="step-start__sub-step" text={i18n.get("", "Paso 1:")} />
                                <br />
                                <CustomText
                                    className="step-start__sub-step-title"
                                    text={i18n.get("onboarding.enrolled.user.stepStart.2", "Permisos y verificación")}
                                />
                            </b>
                            <>
                                <br />
                                <CustomText
                                    text={i18n.get("onboarding.enrolled.user.stepStart.3", "CUIT de tu empresa")}
                                />
                                <br />
                                <CustomText
                                    text={i18n.get(
                                        "onboarding.enrolled.user.stepStart.4",
                                        "Tu número de celular y email",
                                    )}
                                />
                            </>
                            <br />
                        </div>
                    </div>
                    <hr className="dotted" />
                    <div className="paso2">
                        <div>
                            <b>
                                <CustomText className="step-start__sub-step" text={i18n.get("", "Paso 2:")} />
                                <br />
                                <CustomText
                                    className="step-start__sub-step-title"
                                    text={i18n.get(
                                        "onboarding.enrolled.user.stepStart.5",
                                        "Validación de credenciales",
                                    )}
                                />
                            </b>
                            <br />
                            <CustomText
                                text={i18n.get(
                                    "onboarding.enrolled.user.stepStart.6",
                                    "Para validar CUIL, usuario y contraseña",
                                )}
                            />
                            <br />
                        </div>
                    </div>
                    <hr className="dotted" />
                    <div className="paso3">
                        <div>
                            <b>
                                <CustomText className="step-start__sub-step" text={i18n.get("", "Paso 3:")} />
                                <br />
                                <CustomText
                                    className="step-start__sub-step-title"
                                    text={i18n.get("onboarding.enrolled.user.stepStart.7", "Selección de rol")}
                                />
                            </b>
                            <br />
                            <CustomText
                                text={i18n.get(
                                    "onboarding.enrolled.user.stepStart.8",
                                    "Para que puedas empezar a operar en tu nueva empresa.",
                                )}
                            />
                            <br />
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <Button bsStyle="primary" label="global.begin" loading={false} onClick={onStart} block />
                </div>
            </MainContainer>
        </Fragment>
    );
};

StepStart.propTypes = {
    isMobile: bool.isRequired,
};

export default StepStart;
